import React from 'react';
import { useTranslation } from 'react-i18next';
import CapabilityDisclosure from '@components/capabilities/CapabilityDisclosure';
import { labelsFor } from '@constants/mimeLabels';
import type { CapabilityStatus } from '@hooks/useCapabilities';
import type { UploadCapability } from '@services/settings.service';

interface UploadLimitsPanelProps {
  status: CapabilityStatus;
  upload?: UploadCapability;
  onRetry: () => void;
}

const UploadLimitsPanel: React.FC<UploadLimitsPanelProps> = ({ status, upload, onRetry }) => {
  const { t } = useTranslation();

  return (
    <CapabilityDisclosure
      status={status}
      hasValues={Boolean(upload)}
      titleKey="upload.limitsTitle"
      onRetry={onRetry}
    >
      {upload && (
        <>
          <li>{t('upload.limitsFormats', { types: labelsFor(upload.allowedMimeTypes) })}</li>
          <li>{t('upload.limitsMaxSize', { size: upload.maxFileSizeMb })}</li>
          <li>{t('upload.limitsMaxFiles', { count: upload.maxSimultaneousFiles })}</li>
          {upload.allowedMimeTypes.includes('text/csv') && <li>{t('upload.csvScope')}</li>}
          {upload.allowedMimeTypes.includes('application/vnd.ms-excel.sheet.macroenabled.12') && (
            <li>{t('upload.xlsmScope')}</li>
          )}
        </>
      )}
    </CapabilityDisclosure>
  );
};

export default UploadLimitsPanel;
